/*
 * Variable declarations
 */
const modalOverlay = document.querySelector('#modal-overlay');
const klaviyo_popup = document.querySelector('#klaviyo_popup');
const klaviyo_popup__grid = document.querySelector('.grid');
const klaviyo_popup__close = document.querySelector('#klaviyo_popup__close');
const klaviyo_popup__dismiss = document.querySelector('#klaviyo_popup__dismiss');
const klaviyo_popup__required = document.querySelector('#klaviyo_popup__required');
const klaviyo_popup__submit = document.querySelector('#klaviyo_popup__submit');
const klaviyo_popup__submit_shopNow = document.querySelector('#klaviyo_popup__submit_shopNow');
const klaviyo_popup__shopNow__wrapper= document.querySelector('#klaviyo_shopNow__wrapper');
const klaviyo_popup__alertContainer = document.querySelectorAll('.klaviyo-alert-container');
const form = klaviyo_popup.querySelector('form');
const klaviyo_firstName__element = form.querySelector('#klaviyo_firstName');
const skipToContent = document.querySelector('.skip-to-content-link');
const oneTrustButton = document.querySelector('#onetrust-close-btn-container > button');
const oneTrustClose = document.querySelector('#onetrust-accept-btn-handler');

// Cookie management
function shouldDisplayPopup() {
  return localStorage.getItem('popupClosed') !== 'true';
}

function closePopup() {
  klaviyo_popup.style.display = 'none';
  localStorage.setItem('popupClosed', 'true');
}

// Logic for submitting form, error handling, validation, and Klaviyo API call
form.addEventListener('submit', async (event) => {
  event.preventDefault();
  event.stopPropagation();

  document.querySelectorAll('.js-validate').forEach((inputEl) => {
    if (inputEl.value !== '') {
      updateValidationStateForInput(inputEl);
    }
  });

  const isFormValid = form.checkValidity();
  // Focus on invalid input if exists, and prevent form submission
  if (!isFormValid) {
    const firstInvalidInputEl = form.querySelector('input:invalid');
    firstInvalidInputEl?.focus();
  } else {
    const klaviyo_firstName = form.querySelector('#klaviyo_firstName').value;
    const klaviyo_email = form.querySelector('#klaviyo_email').value;

    try {
      const response = await fetch('https://apigeex2.juicyorange.com/epic/register', {
        method: 'POST',
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          first_name: klaviyo_firstName.toString(),
          email: klaviyo_email.toString(),
          subscribe: 'true',
          consent: 'true',
          source_code: 20004
        })
      }).then(response => response.json()).then(data => {
        if (data.UserId) {
          document.cookie = "gmi.profile.id=" + data.UserId + "; path=/; secure=true";
          document.cookie = "gmi.profile.unified.id=" + data.UnifiedId + "; path=/; secure=true";
          document.cookie = "gmi.profile.status=EmailOnly; path=/; secure=true";

          localStorage.setItem('popupClosed', 'true');
          klaviyo_popup__alertContainer.forEach((element) => {
            element.style.display = 'none';
          })
          form.querySelector('h1').setAttribute('tabindex', '-1');
          form.querySelector('h1').textContent = 'UNLOCKED';
          form.querySelector('h1').focus();
          form.querySelector('p').innerHTML = 'Enjoy 15% off your first order with code:';
          form.querySelector('p').style.padding = '0px';
          const codeElement = document.createElement('p');
          codeElement.textContent = 'WELCOME15';
          form.querySelector('p').appendChild(codeElement);
          const successMessage = document.querySelector('#successMessage');
          successMessage.textContent = 'Form submitted successfully! Enjoy 15% off your first order with code WELCOME15';

          klaviyo_popup__submit_shopNow.style.display = "flex";
          klaviyo_popup__submit.style.display = "none";
          klaviyo_popup__dismiss.style.display = 'none';
          klaviyo_popup__required.style.display = 'none';
          klaviyo_popup__shopNow__wrapper.style.display = "none";

          const formElements = form.querySelectorAll('select, option, label, input, aside');
          formElements.forEach(element => {
            element.style.display = 'none';
          });
        } else {
          const formElements = form.querySelectorAll('select, option, label, input, aside');
          formElements.forEach(element => {
            element.style.display = 'none';
          });
          klaviyo_popup__alertContainer.forEach((element) => {
            element.style.display = 'none';
          });
          klaviyo_popup__submit.style.display = "none";
          klaviyo_popup__shopNow__wrapper.style.display = "none";
          form.querySelector('h1').textContent = 'There was an issue subscribing. Please try again.';
          form.querySelector('h1').focus();
        }
      })
      console.log(response);
    } catch (err) {
      console.error(err);
    }
  }
});

// Validation function
const updateValidationStateForInput = (inputEl) => {
  const isInputValid = inputEl.checkValidity();

  if (!inputEl.required && inputEl.value === '' && isInputValid) {
    inputEl.classList.remove('is-valid', 'is-invalid');
  } else {
    inputEl.classList.toggle('is-valid', isInputValid);
    inputEl.classList.toggle('is-invalid', !isInputValid);
  }

  inputEl.setAttribute('aria-invalid', (!isInputValid).toString());

  const errorEl = inputEl.nextElementSibling;

  errorEl.textContent = getValidationMessageForInput(inputEl);
  errorEl.hidden = isInputValid;
}

// Custom validation message
const getValidationMessageForInput = (inputEl) => {
  if (inputEl.validity.valid) return '';

  if (inputEl.name === "klaviyo_firstName") {
    if (inputEl.validity.valueMissing) {
      return 'Please enter your name';
    }
    if (inputEl.validity.typeMismatch) {
      return 'Please enter a valid name';
    }
  } else if (inputEl.name === "klaviyo_email") {
    if (inputEl.validity.valueMissing) {
      return 'Please enter an email address';
    }
    if (inputEl.validity.typeMismatch) {
      return 'Please enter a valid email address';
    }
  } else {
    return inputEl.validationMessage;
  }
}

// Certain actions should happen on page load, after OneTrust
window.onload = function () {
 if (oneTrustButton) {
  oneTrustButton.addEventListener('keydown', (e) => {
    if (e.key === 'Tab' && !e.shiftKey) {
      klaviyo_popup__close.focus();
    }
  });

  oneTrustButton.addEventListener('click', () => {
    sessionStorage.setItem('closeButtonClicked', 'true')
  });

  oneTrustClose.addEventListener('click', () => {
    sessionStorage.setItem('closeButtonClicked', 'true')
  });
 }

  document.querySelectorAll('.js-validate').forEach((inputEl) => {
    inputEl.addEventListener('input', (e) => {
      updateValidationStateForInput(e.target);
    })

    inputEl.addEventListener('blur', (e) => {
      updateValidationStateForInput(e.target);
    });

    inputEl.setAttribute('aria-invalid', 'false');
  });

  form.setAttribute('novalidate', '');

  klaviyo_popup.dataset.jsEnabled = 'true';
};

setTimeout(() => {
  const closeButtonClicked = sessionStorage.getItem('closeButtonClicked');

  if (shouldDisplayPopup()) {
    klaviyo_popup.style.display = "block";
    klaviyo_popup__grid.style.display = "grid";
    modalOverlay.classList.toggle('modal-overlay');

    if (closeButtonClicked === 'true' || !oneTrustButton) {
      klaviyo_firstName__element.focus();
    };
  }
}, 500);

/*
 Focus Management logic
*/
klaviyo_popup__close.addEventListener('click', function() {
  closePopup();
  klaviyo_popup.style.display = 'none';
  modalOverlay.classList.toggle('modal-overlay');
  if (klaviyo_popup) {
    setTimeout(() => {
      skipToContent.focus();
    }, 150)
  }
});

klaviyo_popup__dismiss.addEventListener('click', function() {
  closePopup();
  klaviyo_popup.style.display = 'none';
  modalOverlay.classList.toggle('modal-overlay');
  if (klaviyo_popup) {
    setTimeout(() => {
      skipToContent.focus();
    }, 150)
  }
});

window.addEventListener("click", function (e) {
  if (e.target === modalOverlay) {
    klaviyo_popup.style.display = "none";
    modalOverlay.classList.toggle('modal-overlay');
    localStorage.setItem('popupClosed', 'true');
    if (klaviyo_popup) {
      setTimeout(() => {
        skipToContent.focus();
      }, 150)
    }
  }
});

klaviyo_popup.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    klaviyo_popup.style.display = "none";
    modalOverlay.classList.toggle('modal-overlay');
    localStorage.setItem('popupClosed', 'true');
    if (klaviyo_popup) {
      setTimeout(() => {
        skipToContent.focus();
      }, 150)
    }
  }
})

klaviyo_popup__dismiss.addEventListener('keydown', (e) => {
  if (e.key === 'Tab' && !e.shiftKey) {
    e.preventDefault();
    klaviyo_popup__close.focus();
  }
})

klaviyo_popup__close.addEventListener('keydown', (e) => {
  if (e.key === 'Tab' && e.shiftKey) {
    e.preventDefault();
    klaviyo_popup__dismiss.focus();
  }
})

klaviyo_popup__submit_shopNow.addEventListener('keydown', (e) => {
  if (e.key === 'Tab' && !e.shiftKey) {
    e.preventDefault();
    klaviyo_popup__close.focus();
  }
})
